type Props = {
  value: number;
  options: {label: string; value: number}[];
  placeholder?: string;
};
export const RatingStatus = ({value, options, placeholder}: Props) => {
  return (
    <div className="rating-status">
      {options.find(option => option.value === value)?.label || placeholder}
    </div>
  );
};
